export const firebaseConfig = {
	apiKey: "AIzaSyCbeB1UL0Lt3kwspV0CdoY-pIWkywP5A0k",
	authDomain: "curbd-io.firebaseapp.com",
	projectId: "curbd-io",
	storageBucket: "curbd-io.appspot.com",
	messagingSenderId: "445683283505",
	appId: "1:445683283505:web:567a00f5e8d0066e880710",
	measurementId: "G-S790B255GD"
}